import React, { useState } from 'react'
import { FormBox, InputBox } from '../../../components/AntdAddons';
import { Button, Col, Form, Layout, Row, Space } from 'antd';
import { validations } from '../../../config/validations/validations';
import { Link, useParams } from 'react-router-dom';
import FooterView from '../../layouts/MainLayout/FooterView';
import { CONSTANT } from '../../../config/Constant';
import { updateEmailSupportStatus } from '../../../store/SendEmailSupportSlice';
import { AppDispatch } from '../../../store/app';
import { useDispatch } from 'react-redux';
import LogoComponent from '../../layouts/Components/LogoComponent';

type RouteParams = { id: string } & Record<string, string | undefined>;
const Index: React.FC<any> = () => {
    const [form] = Form.useForm();
    const dispatch: AppDispatch = useDispatch();
    const [saving, setSaving] = useState<boolean>(false);
    const [requiredReason, setRequiredReason] = useState<boolean>(true);
    const { id, providerId } = useParams<RouteParams>();

    const handleSubmit = (data: any) => {
        const payload = {
            ...data,
            id: id,
            ProviderId: providerId
        }
        dispatch(updateEmailSupportStatus(payload))
            .then(() => {
                form.resetFields();
            })
            .catch((e: any) => {
                console.warn(e);
            })
            .finally(() => setSaving(false));
    }
    const handleChange = () => {
        form
            .validateFields()
            .then(() => {
                // setDisable(false);
            })
            .catch((error: any) => {
                // setDisable(true);
            });
    };

    return (
        <>
            <Layout.Header className='main__page__appheader'>
                <div className='appheader__left'>
                    <LogoComponent />
                </div>
            </Layout.Header>
            <section
                className="section pagenotfound__section"
                style={{ height: 'calc(100dvh - 80px)' }}
            >

                <FormBox
                    className='filterForm'
                    form={form}
                    onFinish={handleSubmit}
                    onChange={handleChange}
                    validateTrigger={['onBlur', 'onInput']}
                    id='updateStatus'
                >
                    <Row gutter={30}>
                        <Col span={24}>
                            <InputBox.Select
                                label="Status"
                                name={'status'}
                                required
                                placeholder="Select Status"
                                onChange={(e: any) => {
                                    handleChange()
                                    if (e !== "Completed") {
                                        setRequiredReason(true)
                                    } else {
                                        setRequiredReason(false)
                                    }
                                }}
                                options={{
                                    list: CONSTANT.STATUS,
                                    valueKey: 'value',
                                    textKey: 'id',
                                }}
                                rules={[validations.required.select('Status')]}
                            />
                        </Col>
                        <Col span={24}>
                            <InputBox.TextArea
                                required={requiredReason}
                                name={"reason"}
                                placeholder='Reason'
                                label="Reason"
                                rows={2}
                                rules={requiredReason ?
                                    [
                                        validations.required.text('Reason'),
                                    ] : [
                                        { required: false }
                                    ]
                                }
                            />
                        </Col>
                    </Row>
                    <Row gutter={30}>
                        <Col span={8}>
                            <Button
                                type="primary"
                                htmlType="submit"
                                loading={saving}
                            >
                                Submit
                            </Button>
                        </Col>
                    </Row>
                </FormBox>
                <p className="notFoundText text-center">Thank you for confirming that the routing has been carried out.</p>
                <Space
                    size="large"
                >
                    <Button
                        size="large"
                        type="primary"
                    >
                        <Link to={'/'}>Back Home</Link>
                    </Button>
                </Space>
            </section>
            <FooterView />
        </>
    )
}

export default Index